export const NPS_PREVIEW_REPLY_SCORE = 6

export const getNpsCategoryKeyByScore = (score: number) => {
  if (score >= 9) return 'promoters'
  if (score >= 7) return 'passives'
  return 'detractors'
}
